import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { murmurhash } from '../../../../lib/js/hash';
import { DateRanger } from '../../../molecules/DateRanger/DateRanger';
import { Namespace } from '../../../../translation/namespace';
import { HyperlinkTarget } from '../../../atoms/Hyperlink';
import { ContentLink } from '../../../../_lib/components/ContentLink';
import { ContentParagraph } from '../../../../_lib/components/ContentParagraph';
import { formatDate, isDateBefore, TimeFormats } from '../../../../lib/DateFormat';

export default function EventDetailsView({
  startDate,
  endDate,
  location = null,
  additionalInfo = null,
  conferenceRoomUrl = null,
  allDay,
}) {
  const { t } = useTranslation();
  const renderContentParagraph = content => {
    return <ContentParagraph>{content}</ContentParagraph>;
  };

  const renderConferenceRoomUrl = () => {
    return (
      <ContentLink
        id={murmurhash(conferenceRoomUrl)}
        to={conferenceRoomUrl}
        external
        newWindowIndicator
        target={HyperlinkTarget.BLANK}
        title={t(`${Namespace.phrases}:linkOpensInNewWindow`)}
        tooltipPlacement="bottom"
      >
        {t(`${Namespace.EventDetails}:linkTitle`)}
      </ContentLink>
    );
  };

  const isMultiDayEvent = (startDate, endDate) => {
    return (
      formatDate(startDate, 'DD.MM.YYYY') !== formatDate(endDate, TimeFormats.DAY_MONTH_YEAR) &&
      isDateBefore(startDate, endDate)
    );
  };

  return (
    <div className="event-details-view">
      <div className="event-details-view__date font-regular-15-19">
        <DateRanger
          start={startDate}
          end={endDate}
          multiDayEvent={isMultiDayEvent(startDate, endDate)}
          allDayEvent={allDay}
        />
      </div>
      {location && renderContentParagraph(`${t(`${Namespace.glossary}:meetingLocation`)}: ${location}`)}
      {additionalInfo && renderContentParagraph(additionalInfo)}
      {conferenceRoomUrl && renderConferenceRoomUrl()}
    </div>
  );
}

EventDetailsView.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  location: PropTypes.string,
  additionalInfo: PropTypes.string,
  conferenceRoomUrl: PropTypes.string,
  allDay: PropTypes.bool.isRequired,
};
